import { Backdrop, Grid, Stack } from "@mui/material"
import { useState } from "react"

const Agenda = () => {
    const [openBack, setOpenBack] = useState(false);
    const [imgSrc, setImgSrc] = useState('');

    const handleOpen = (src) => {
        setImgSrc(src)
        setOpenBack(true);
    }

    return (
        <>
            <Backdrop open={openBack} sx={{ zIndex: 2000 }} onClick={() => setOpenBack(false)}>
                <img src={imgSrc} style={{ width: "30%" }} />
            </Backdrop>


            <Grid container flexDirection="row" spacing={1}>
                <Grid item xs={6}>
                    <Stack direction='column' spacing={1} alignItems='center'>
                        <img className="more-info" onClick={() => handleOpen("/images/agenda/1-2.jpg")} src="/images/agenda/1-1.jpg" style={{ width: "100%" }} />
                        <div class='more-info-text'>Click para más información</div>
                    </Stack>
                </Grid>
                <Grid item xs={6}>
                    <Stack direction='column' spacing={1} alignItems='center'>
                        <img className="more-info" onClick={() => handleOpen("/images/agenda/2-2.jpg")} src="/images/agenda/2-1.jpg" style={{ width: "100%" }} />
                        <div class='more-info-text'>Click para más información</div>
                    </Stack>
                </Grid>
            </Grid>
            <Grid container flexDirection="row" spacing={1} mt={0.5}>
                <Grid item xs={6}>
                    <Stack direction='column' spacing={1} alignItems='center'>
                        <img className="more-info" onClick={() => handleOpen("/images/agenda/3-2.jpg")} src="/images/agenda/3-1.jpg" style={{ width: "100%" }} />
                        <div class='more-info-text'>Click para más información</div>
                    </Stack>
                </Grid>
                <Grid item xs={6}>
                    <Stack direction='column' spacing={1} alignItems='center'>
                        <img className="more-info" onClick={() => handleOpen("/images/agenda/4-2.jpg")} src="/images/agenda/4-1.jpg" style={{ width: "100%" }} />
                        <div class='more-info-text'>Click para más información</div>
                    </Stack>
                </Grid>
            </Grid>


            {/* <Grid container flexDirection="column" spacing={3}>
                <Grid item>
                    <Grid container flexDirection='row' spacing={1}>
                        <Grid item xs={6}>
                            <Stack direction='column' spacing={1} alignItems='center'>
                                <img className="more-info" onClick={() => handleOpen("/images/agenda/1-2.jpg")} src="/images/agenda/1-1.jpg" style={{ width: "80%" }} />
                                <div class='more-info-text'>Click para más información</div>
                            </Stack>
                        </Grid>
                        <Grid item xs={6}>
                            <Stack direction='column' spacing={1} alignItems='center'>
                                <img className="more-info" onClick={() => handleOpen("/images/agenda/2-2.jpg")} src="/images/agenda/2-1.jpg" style={{ width: "80%" }} />
                                <div class='more-info-text'>Click para más información</div>
                            </Stack>
                        </Grid>
                        <Grid item xs={6}>
                            <Stack direction='column' spacing={1} alignItems='center'>
                                <img className="more-info" onClick={() => handleOpen("/images/agenda/3-2.jpg")} src="/images/agenda/3-1.jpg" style={{ width: "80%" }} />
                                <div class='more-info-text'>Click para más información</div>
                            </Stack>

                        </Grid>
                        <Grid item xs={6}>
                            <Stack direction='column' spacing={1} alignItems='center'>
                                <img className="more-info" onClick={() => handleOpen("/images/agenda/4-2.jpg")} src="/images/agenda/4-1.jpg" style={{ width: "80%" }} />
                                <div class='more-info-text'>Click para más información</div>
                            </Stack>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid> */}
        </>
    )
}

export default Agenda